import { useTheme } from '../context/ThemeContext.jsx';

export default function DuplicatePrompt({ duplicates, onSkip, onReplace, onCancel }) {
  const { theme } = useTheme();

  return (
    <div
      onClick={onCancel}
      style={{
        position: 'fixed', inset: 0, zIndex: 300,
        background: theme.overlay,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          width: 440, maxHeight: '80vh',
          background: theme.bg,
          border: `2px solid ${theme.text}`,
          display: 'flex', flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {/* Header */}
        <div style={{ padding: '18px 20px 14px', borderBottom: `1px solid ${theme.border}` }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
            <span style={{ fontSize: 20 }}>⚠️</span>
            <span style={{ fontFamily: "'Aeonik', Arial, Helvetica, sans-serif", fontWeight: 450, fontSize: 18, color: theme.text }}>
              duplicate fonts detected
            </span>
          </div>
          <div style={{ fontSize: 12, color: theme.textFaint, paddingLeft: 30 }}>
            {duplicates.length} font{duplicates.length !== 1 ? 's' : ''} already exist in your library.
            what would you like to do?
          </div>
        </div>

        {/* Duplicate list */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '10px 20px' }}>
          {duplicates.map((d, i) => (
            <div
              key={i}
              style={{
                display: 'flex', alignItems: 'center', gap: 10,
                padding: '7px 0',
                borderBottom: i < duplicates.length - 1 ? `1px solid ${theme.borderLight}` : 'none',
              }}
            >
              <div style={{ width: 6, height: 6, borderRadius: '50%', background: theme.orange, flexShrink: 0 }} />
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{
                  fontSize: 12, fontWeight: 600, color: theme.textSecondary,
                  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                }}>{d.existingFamily}</div>
                <div style={{ fontSize: 10, color: theme.textGhost }}>
                  {d.name} → already in library
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Actions */}
        <div style={{ padding: '14px 20px', borderTop: `1px solid ${theme.border}`, display: 'flex', gap: 8, flexDirection: 'column' }}>
          <button
            onClick={onSkip}
            style={{
              padding: '10px 0', borderRadius: 0, border: 'none',
              background: theme.fill,
              color: theme.fillFg, fontSize: 13, textTransform: 'lowercase',
              cursor: 'pointer', fontFamily: 'inherit',
            }}
          >
            skip duplicates <span style={{ opacity: 0.7, fontSize: 11 }}>(recommended)</span>
          </button>
          <button
            onClick={onReplace}
            style={{
              padding: '9px 0', borderRadius: 0,
              border: `1px solid ${theme.borderMedium}`,
              background: 'transparent',
              color: theme.textSecondary, fontSize: 13, textTransform: 'lowercase',
              cursor: 'pointer', fontFamily: 'inherit',
            }}
          >
            replace existing
          </button>
          <span
            onClick={onCancel}
            style={{ padding: '8px 0', textAlign: 'center', color: theme.textFaint, fontSize: 12, textTransform: 'lowercase', cursor: 'pointer' }}
          >
            cancel upload
          </span>
        </div>
      </div>
    </div>
  );
}
